var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (answers, continueBtnText, doneText, game, hasNarration, hasPrompt, i18n, prompt, submitUp, title, undefined) {
if ( game && game.timer && game.timer.limit > 0 && !game.timer.isDisabled)
{
buf.push("<div class=\"full-screen\"><div class=\"game-stepper text-lg text-bold\"></div><div class=\"game-progress\"><div class=\"game-progress-bar\"></div></div></div>");
}
buf.push("<div class=\"content-fill\"><div class=\"content-md-fill content-sm-ver content-fit\"><div class=\"content-md-ver text-center block-v-lg\"><h1 class=\"block-h-xl fade-in\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</h1><div class=\"row carousel-container block-h-xl block-v-lg\"><div class=\"col-md-8 col-md-offset-2 col-sm-12\"><div class=\"carousel slide-up delay-6\"><div" + (jade.attr("style", "width: " + (answers.length * 100) + "%;", true, false)) + " class=\"carousel-slider block-flex-ver clearfix\">");
// iterate answers
;(function(){
  var $$obj = answers;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var answer = $$obj[$index];

buf.push("<div" + (jade.attr("data-is-correct", answer.correct, true, false)) + (jade.attr("data-answer-id", answer.id, true, false)) + (jade.attr("style", "width: " + (100 / answers.length) + "%;", true, false)) + (jade.cls(['carousel-item','block-md',answer.correct ? "carousel-item-correct" : ""], [null,null,true])) + "><div class=\"carousel-block block-md block-dk draggy draggy-ver delay-3\"><div" + (jade.cls(['carousel-btn','btn','btn-solid','btn-block',answer.content.length > 20 ? "btn-long" : ""], [null,null,null,null,true])) + "><div class=\"text-center\">" + (null == (jade_interp = answer.content) ? "" : jade_interp) + "</div></div></div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var answer = $$obj[$index];

buf.push("<div" + (jade.attr("data-is-correct", answer.correct, true, false)) + (jade.attr("data-answer-id", answer.id, true, false)) + (jade.attr("style", "width: " + (100 / answers.length) + "%;", true, false)) + (jade.cls(['carousel-item','block-md',answer.correct ? "carousel-item-correct" : ""], [null,null,true])) + "><div class=\"carousel-block block-md block-dk draggy draggy-ver delay-3\"><div" + (jade.cls(['carousel-btn','btn','btn-solid','btn-block',answer.content.length > 20 ? "btn-long" : ""], [null,null,null,null,true])) + "><div class=\"text-center\">" + (null == (jade_interp = answer.content) ? "" : jade_interp) + "</div></div></div></div>");
    }

  }
}).call(this);

buf.push("</div></div></div></div></div></div></div><div class=\"pagination\">");
// iterate answers
;(function(){
  var $$obj = answers;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var answer = $$obj[i];

buf.push("<div class=\"page\"></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var answer = $$obj[i];

buf.push("<div class=\"page\"></div>");
    }

  }
}).call(this);

buf.push("</div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"answers" in locals_for_with?locals_for_with.answers:typeof answers!=="undefined"?answers:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"game" in locals_for_with?locals_for_with.game:typeof game!=="undefined"?game:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}